export default [
    {
        title: "400 Points",
        description: "Free Regular Popcorn",
        available: true,
        points:400,
        nextPoints:800,
        color: null,
        icon: 'popcorn',
        test: (reward)=> {
            return ~reward.Description.toLowerCase().indexOf("400 points");
        }
    },
    {
        title: "800 Points",
        description: "Free Coke & Popcorn Combo",
        available: true,
        points:800,
        nextPoints:1000,
        color: 'green',
        icon: 'combo',
        test: (reward)=> {
            return ~reward.Description.toLowerCase().indexOf("800 points");
        }
    },
    {
        title: "1000 Points",
        description: "Free Movie Ticket",
        available: true,
        points:1000,
        nextPoints:1200,
        redirect:'/?filter=reward',
        color: 'yellow',
        icon: 'free-movieticket',
        test: (reward)=> {
            return ~reward.Description.toLowerCase().indexOf("1000 points");
        }
    },
    {
        title: "1200 Points",
        description: "Free 3D Movie Ticket",
        redirect:'/?filter=3D',
        available: false,
        points:1200,
        nextPoints:1500,
        color: 'orange',
        icon: 'ticket-3d',
        test: (reward)=> {
            return ~reward.Description.toLowerCase().indexOf("1200 points");
        }
    },

    {
        title: "1500 Points",
        points:1500,
        available: true,
        nextPoints:0,
        description: "Free Cine Prestige Movie Ticket",
        redirect:'/?filter=prestige',
        color: 'red',
        icon: 'prestige-movieticket',
        test: (reward)=> {
            return ~reward.Description.toLowerCase().indexOf("1500 points");
        }
    },

    {
        title: "Birthday",
        description: "Birthday Movie Ticket",
        available: true,
        color: 'purple',
        redirect:'/?filter=reward',
        icon: 'birthday',
        test: (reward)=> {
            return ~reward.Description.toLowerCase().indexOf("birthday");
        }
    },

]


// WEBPACK FOOTER //
// ./src/components/pages/user/badgeConfig.js